import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { logout } from "../data/Reducers/UserReducer";
import { clearStoredSession } from "../data/authStorage";

const useSessionExpired = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isHandlingRef = useRef(false);

  useEffect(() => {
    const handleSessionExpired = () => {
      // Prevent duplicate handling
      if (isHandlingRef.current) return;
      isHandlingRef.current = true;

      // Show a single toast notification
      toast.error("Your session has expired. Please login again.", {
        position: "top-right",
        autoClose: 5000,
      });

      // Clear localStorage and Redux auth state
      clearStoredSession();
      dispatch(logout());

      // Redirect immediately so an open modal or stale page cannot remain
      // interactive after authentication has been invalidated.
      navigate("/login", { replace: true });
    };

    // Listen for the sessionExpired event
    window.addEventListener("sessionExpired", handleSessionExpired);

    return () => {
      window.removeEventListener("sessionExpired", handleSessionExpired);
    };
  }, [navigate, dispatch]);
};

export default useSessionExpired;
